import type { WalkthroughEvent } from '@shared-types/frontend-scenario-definition';
import participantViewWalkthrough from './participant-view-walkthrough';
import adminViewWalkthrough from './admin-view-walkthrough';
import participantActivityWalkthrough from './participant-activity-walkthrough';
import participantReportWalkthrough from './participant-report-walkthrough';
import participantViewWalkthroughWithAIAssistant from './participant-view-walkthrough-with-ai-assistant';

const walkthroughs = {
    participantViewWalkthrough,
    participantActivityWalkthrough,
    participantReportWalkthrough,
    adminViewWalkthrough,
    participantViewWalkthroughWithAIAssistant,
};

export const walkthroughEvents: Record<string, WalkthroughEvent> = Object.fromEntries(
    Object.entries(walkthroughs).map(([, value]) => [value.key, value]),
);
